import { createContext } from "react";

const CardDetailsContext = createContext(null);

export default CardDetailsContext;
